<template>
  <b-card>
    <validation-observer
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <b-row>
        <b-col
          md="6"
        >
          <validation-provider
            #default="validationContext"
            rules="required"
            name="user"
          >

            <b-form-group
              label="user"
              label-for="user"
            >
              <v-select
                id="user_id"
                v-model="reimbursementForm.user_id"
                :options="optionsAllUser"
                :reduce="option => option.value.id"
                trim
                placeholder="user"
                value="id"
                :state="getValidationState(validationContext)"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>

          </validation-provider>
        </b-col>

        <b-col
          md="6"
        >
          <validation-provider
            #default="validationContext"
            rules="required"
            name="Description"
          >

            <b-form-group
              label=" Description "
              label-for=" Description"
            >
              <b-form-input
                id="description"
                v-model="reimbursementForm.description"
                trim
                placeholder="Description"
                :state="getValidationState(validationContext)"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>

          </validation-provider>
        </b-col>

        <b-col
          md="6"
        >
          <validation-provider
            #default="validationContext"
            rules="required"
            name="amount"
          >

            <b-form-group
              label=" amount "
              label-for=" amount"
            >
              <b-form-input
                id="amount"
                v-model="reimbursementForm.amount"
                trim
                placeholder="amount"
                :state="getValidationState(validationContext)"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>

          </validation-provider>
        </b-col>

        <b-col
          md="6"
        >
          <b-form-group
            label=" request code "
            label-for=" request code"
          >
            <b-form-input
              id="request_code"
              v-model="reimbursementForm.request_code"
              trim
              placeholder="request code"
            />
          </b-form-group>
        </b-col>

        <b-col
          md="12"
        >
          <b-form-group
            label=" attachments "
            label-for=" attachments"
          >
            <b-form-file
              id="attachments"
              v-model="reimbursementForm.attachments"
              multiple
              placeholder="attachments"
            />
          </b-form-group>
        </b-col>

        <!-- Server Errors -->
        <b-col
          v-if="Object.values(errors).length > 0"
          cols="12"
        >
          <p
            v-for="(error, key, index) in errors"
            :key="index"
            class="text-danger small"
          >
            {{ error.toString() }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="mt-50"
        >

          <b-button
            v-if="!loader && $route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addproduct()"
          >
            Save Changes
          </b-button>
          <b-button
            v-if="!loader && !$route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addproduct()"
          >
            Add
          </b-button>
          <b-button
            v-if="loader"
            variant="primary"
            disabled
            class="mr-1"
          >
            <b-spinner
              small
              type="grow"
            />
            Loading...
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import VSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import decryptData from '@/store/auth/decryptData'

export default {
  components: {
    'v-select': VSelect,
  },
  data() {
    return {
      id: this.$store.state.generalIds.id,
      required,
      loader: false,
      loadtable: false,
      validationErrors: {},
      errors: {},
    }
  },
  setup() {
    const { getValidationState } = formValidation()
    // eslint-disable-next-line camelcase

    const reimbursementForm = ref({})
    return {
      getValidationState,
      reimbursementForm,
    }
  },
  computed: {

    optionsAllUser() {
      return this.$store.getters['generalData/assignList/assignList']
    },
  },
  async mounted() {
    this.getReimbursement()
    if (!this.$store.getters['generalData/assignList/assignListLoaded']) {
      this.loadtable = true
      await this.$store.dispatch('generalData/assignList/fetchAssignList')
      this.loadtable = false
    }
  },
  methods: {

    getReimbursement() {
      if (this.$route.params.id) {
        axios.get(`reimbursement/${this.$route.params.id}`).then(res => {
          const getData = decryptData(res.data.payload).data
          this.reimbursementForm = {
            ...getData,
            request_code: getData.request?.request_code || '',
            attachments: [],
          }
        })
      } else {
        return false
      }
      return true
    },
    addproduct() {
      if (this.$route.params.id) {
        this.loader = true
        const formData = new FormData()
        formData.append('_method', 'PUT')

        Object.entries(this.reimbursementForm).forEach(([key, value]) => {
          if (key === 'attachments' && Array.isArray(value)) {
            value.forEach((file, index) => {
              formData.append(`attachments[${index}]`, file)
            })
          } else if (key === 'user_id' && Array.isArray(value)) {
            formData.append('user_id', value.value.id)
          } else {
            formData.append(key, value)
          }
        })

        axios.post(`reimbursement/${this.$route.params.id}`, formData).then(res => {
          if (res.status === 200) {
            this.$router.push({ name: 'reimbursement' })
            this.$toasted.show('Updated Successfully', {
              position: 'top-center',
              duration: 3000,
            })
          }
        }).catch(error => {
          if (error.response.status) {
            const payload = decryptData(error.response.data.payload).message
            const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
            const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : payload || 'An unknown error occurred'
            this.$toast({
              component: ToastificationContent,
              props: {
                title: errorMessage,
                icon: 'BellIcon',
                variant: 'error',
              },
            })
          }
        }).finally(() => {
          this.loader = false
        })
      } else {
        this.loader = true
        const formData = new FormData()
        Object.entries(this.reimbursementForm).forEach(([key, value]) => {
          if (key === 'attachments' && Array.isArray(value)) {
            value.forEach((file, index) => {
              formData.append(`attachments[${index}]`, file)
            })
          } else if (key === 'user_id' && Array.isArray(value)) {
            formData.append('user_id', value.value.id)
          } else {
            formData.append(key, value)
          }
        })

        axios.post('reimbursement', formData).then(res => {
          if (res.status === 200 || res.status === 201) {
            this.$router.push({ name: 'reimbursement' })
            this.$toasted.show('Created Successfully', {
              position: 'top-center',
              duration: 3000,
            })
          }
        }).catch(error => {
          if (error.response.status) {
            const payload = decryptData(error.response.data.payload).message
            const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
            const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : payload || 'An unknown error occurred'
            this.$toast({
              component: ToastificationContent,
              props: {
                title: errorMessage,
                icon: 'BellIcon',
                variant: 'error',
              },
            })
          }
        }).finally(() => {
          this.loader = false
        })
      }
    },
  },

}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>
